import AIInterlocutor from '../pages/AIInterlocutor/index.vue'//ai对话的初始化页面
const routes = [
  {
    path: '/AIInterlocutor',
    name: 'AIInterlocutor',
    component: AIInterlocutor,
  },
];
export default routes